import React, {Component} from "react";
import "./Nav.css";

export default class Nav extends Component {

    render() {
        return (
            <div className={"header-buttons"} layout="" horizontal="">
                <span flex=""><a className={"try-pi-btn header-button-left"} href="https://www.panintelligence.com/"><i className={"fa fa-arrow-left"} aria-hidden="true"/> BACK TO WEBSITE</a></span>
                <span flex=""><a className={"try-pi-btn header-button-right"} href="https://www.panintelligence.com/request-a-demo/">REQUEST A DEMO</a></span>
            </div>
        )
    }
}
